import React, { Component }  from 'react'

import './Echec.css'
class Echec extends Component {

  constructor(props) {
    super(props)
    this.state = {
       ok:''
    }
  
  }

  componentDidMount() {}

  render() {
    const handleValidate = this.props.handleValidate
    const message =this.props.message
    return (
      <>
        {/* <div className="c-app c-default-layout flex-row align-items-center"> */}
          {/* <div id='card_echec' class="animated fadeIn"> */}
            <div id='upper-side_echec'>
            
                <h3 id='status_echec'>
                echec
              </h3>
            </div>
            <div id='lower-side_echec'>
              <p id='message_echec'>
                {message}
              </p>
              <a onClick={handleValidate} id="contBtn_echec">Continuer</a>
            </div>
          {/* </div> */}
        {/* </div> */}
      </>
    )
  }
}

export default Echec
